import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'blg-select-customer-listing',
  templateUrl: './select-customer-listing.component.html',
  styleUrls: ['./select-customer-listing.component.scss']
})
export class SelectCustomerListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
